// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RKb-","field":"styles_field__34RoR","fieldCol":"styles_fieldCol__3YwAK","diffCol":"styles_diffCol__1eNN_","diff":"styles_diff__Td8yp"};